import React, { useEffect } from "react";
import Card from "../../../components/Global/Card";
import { useParams } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import GoBack from "../../../components/Utils/GoBack";
import RegisteProductForm from "../../../components/Forms/RegisterProductForm";

function EditProduct() {
  const { id } = useParams();

  return (
    <div className="flex flex-col w-full gap-3">
      <GoBack path="/dashboard" />
      <Card title="Editar Produto" icon={<FaEdit className="w-[25px] h-[25px]" />}>
        <div className="p-4 flex flex-col gap-5 w-full">
          <RegisteProductForm id={id} tipo=""/>
        </div>
      </Card>
    </div>
  );
}

export default EditProduct;
